export default function HomePage () {
    return (
        <div className="container">
            <h3>About Stillwind Farm</h3>
            <p>Stillwind Farm was established in 2021 on 1/8 acre urban plot in 
                Muskegon Heights. The farm has since expanded to a 1/2 acre field 
                in Belding - a move that grants an opportunity for permanent 
                infrastructure & more space to grow crops. Collectively, Mikayla & 
                Brian have been farming for 8 seasons & have gained experience on 
                7 different West Michigan farms.</p>

            <p>Stillwind is committed to fostering a relationship with the land & 
                providing folks with beautiful, high quality produce. This looks like:</p>
            <ul>
            <li>Minimal / no tillage - our space is human scale, with all beds being flipped, 
                amended & formed with hand tools. Microorganisms in the soil appreciate this, 
                as there is little disruption to the bed & soil nutrients.</li>
            <li>No spray - broadly, we do not spray at all. If there is a situation where we 
                spray, it is always with organic certified options. We rely largely on a 
                healthy ecosystem, beneficial insects, & strong soil structure to mitigate 
                pests & diseases.</li>
            <li>Investment in high quality soil inputs that balance necessary nutrients each 
                season (based on soil testing). This could look like gypsum, kelp, compost, 
                chicken manure, molasses, fish emulsion, etc. Each of which offer different 
                benefits based on the love the field desires.</li>
            <li>Rotating crops throughout the season. This is important for soil health & 
                decreasing pest / disease pressure. This intersects directly with the overall 
                sustainability of the farm.</li>
            <li>Striving to be a business that does not glorify over-working, sets aside time 
                for rest & community, & chooses not to hire people at a low rate, but rather 
                waiting until we are able to fairly compensate staff / offer benefits. If those 
                growing are consistently burned out, our connection to the growing plants & 
                those around us is effected.</li>
            </ul>
            <p>You can find our veggies at Fulton St Farmers Market on Saturdays throughout the 
                growing season, at The Southeast Market, & through our CSA Share! Follow along 
                on our social media for consistent updates.</p>
        </div>
    )
}